import * as React from "react"
import { BrowserRouter as Router, Route, Routes } from "react-router-dom"
import { ThemeProvider } from "@allied/react-web/Theme"
import { MetaProvider } from "@allied/react-web/Meta"
import { useGoogleAnalytic } from "@allied/react-web/GoogleAnalytic"
import { routes } from "../../routes"
import "./App.css"

const meta = {
  titleTemplate: "ACS Marine & Shipping Pte Ltd | %s",
  titleFallback: "ACS Marine & Shipping Pte Ltd",
  descriptionFallback: "ACS Marine & Shipping Pte Ltd",
  keywordsFallback: "acs, business, solution, efficient, technology, marine, allied, container, singapore",
  typeFallback: "website",
  urlFallback: window.location.href,
  imageFallback: `${process.env.REACT_APP_PUBLIC_URL}/image/acsm-meta.png`,
  markupSchemaFallback: {
    "@context": "https://schema.org",
    "@type": "LocalBusiness",
    "name": "ACS Marine & Shipping Pte Ltd",
    "image": "https://acsmarine.sg/image/acsm-meta.png",
    "@id": "https://acsmarine.sg/",
    "url": "https://acsmarine.sg/",
    "openingHoursSpecification": {
      "@type": "OpeningHoursSpecification",
      "dayOfWeek": [
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday",
        "Sunday"
      ],
      "opens": "00:00",
      "closes": "00:00"
    },
  },
  twitterSchemaFallback: {
    "card": "summary_large_image",
  }
}

export default function App(): React.JSX.Element {
  const { analytic } = useGoogleAnalytic({
    gaId: process.env.REACT_APP_GOOGLE_ANALYTICS_ID,
    loadDelay: 5000
  })

  analytic.send({ hitType: "pageview", page: window.location.pathname })

  return (
    <ThemeProvider theme="acsm">
      <MetaProvider meta={meta}>
        <Router>
          <Routes>
            {
              routes.map((route, i) => {
                return <Route {...route} key={`route-item-${i}`} />
              })
            }
          </Routes>
        </Router>
      </MetaProvider>
    </ThemeProvider>
  )
}
